import { render, staticRenderFns } from "./er_longterm_empty.vue?vue&type=template&id=b253326c"
import script from "./er_longterm_empty.vue?vue&type=script&lang=js"
export * from "./er_longterm_empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports